import { AccountTypeEnum } from '.spec/self-care/tsTypes';
import { toLower } from 'lodash/fp';

type Profile = {
	accountType: AccountTypeEnum;
	id: string;
};

type CustomerAnalytics<T> = T & { userId: string; op: string; presentAccount: string | never };

export function getCustomerAnalyticsData<T>(object: T, profile: Profile): CustomerAnalytics<T> {
	const o = { ...object } as CustomerAnalytics<T>;

	const { accountType, id: userId } = profile;
	const isPackageMaxi = accountType !== AccountTypeEnum.TRY_IT;

	o.userId = userId;
	o.op = isPackageMaxi ? 'full' : 'light';

	if (isPackageMaxi) {
		o.presentAccount = toLower(accountType);
	}

	return o;
}
